import * as React from "react";
import Button from "../../buttons/Button";
import "./AppOffline.scss";

/**
 * AppOffline component
 * @module
 */
const AppOffline = () => {
  return (
    <div className="appOffline">
      <h1>Údržba portálu</h1>
      <div>Prebieha plánovaná údržba portálu. Ďakujeme za porozumenie a prajeme príjemný deň.</div>
      <Button
        primary
        label="Overiť dostupnosť portálu"
        onClick={() => { window.location.reload() }}
      />
    </div>
  );
}

export default AppOffline;